import React, { forwardRef, HTMLAttributes } from 'react';
import { styled } from '@linaria/react';

const Row = styled.div`
  padding-bottom: 16px;
`;

export default forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>((props, ref) => (
  <Row
    {...props}
    ref={ref}
  />
));
